import React, { useEffect, useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import useStyles from "components/Auth/Login/Styles";
import useActions from "../actions";
import { checkEmailValid, checkFieldValid } from "components/User/Validation";
import { USER_PROP } from "components/User/constants";
import { AppRouteURI } from "router/RoleBasedAccess";
const LoginForm = () => {
  const { login } = useActions();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const classes = useStyles();

  const submitForm = (event) => {
    event.preventDefault();
    login(email, password);
  };

  const textfields = [USER_PROP.EMAIL, USER_PROP.PASSWORD];

  const [fieldChecked, setFieldChecked] = useState(
    Object.fromEntries(textfields.map((each) => [[each], false]))
  );
  const [isFormValid, setIsFormValid] = useState(true);

  useEffect(() => {
    checkFormValidity();
  });

  const checkFormValidity = () => {
    const checkFields = checkEmailValid(email) && !!password;
    setIsFormValid(checkFields);
  };

  return (
    <Container maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form className={classes.form} onSubmit={submitForm} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            error={
              fieldChecked[USER_PROP.EMAIL] &&
              !checkFieldValid(USER_PROP.EMAIL, email)
            }
            onClick={() => {
              setFieldChecked({
                ...fieldChecked,
                [USER_PROP.EMAIL]: true,
              });
            }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            error={
              fieldChecked[USER_PROP.PASSWORD] &&
              !checkFieldValid(USER_PROP.PASSWORD, password)
            }
            onClick={() => {
              setFieldChecked({
                ...fieldChecked,
                [USER_PROP.PASSWORD]: true,
              });
            }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={!isFormValid}
          >
            Sign In
          </Button>
          <Grid container>
            <Grid item xs>
              <Link href={AppRouteURI.RESET_PWD} variant="body2">
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link href={AppRouteURI.REGISTER} variant="body2">
                Sign Up
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
    </Container>
  );
};

export default LoginForm;
